import request from '@/utils/request'

// 获取管理员管理的用户列表
export function getManagedUsers(params) {
  return request({
    url: '/admin/user/list',
    method: 'get',
    params
  })
}

// 封禁用户
export function banUser(userId, reason) {
  return request({
    url: `/admin/user/${userId}/ban`,
    method: 'put',
    params: { reason }
  })
}

// 解封用户
export function unbanUser(userId) {
  return request({
    url: `/admin/user/${userId}/unban`,
    method: 'put'
  })
}

// 重置用户密码
export function resetUserPassword(userId, newPassword) {
  return request({
    url: `/admin/user/${userId}/password`,
    method: 'put',
    params: { newPassword }
  })
}

// 分配用户给管理员
export function assignUserToAdmin(adminId, userId) {
  return request({
    url: '/admin/user/assign',
    method: 'post',
    params: { adminId, userId }
  })
}

// 获取用户列表
export function getUserList(params) {
  return request({
    url: '/admin/user/list',
    method: 'get',
    params
  })
}

// 创建用户
export function createUser(data) {
  return request({
    url: '/admin/user',
    method: 'post',
    data
  })
}

// 更新用户
export function updateUser(userId, data) {
  return request({
    url: `/admin/user/${userId}`,
    method: 'put',
    data
  })
}

// 删除用户
export function deleteUser(userId) {
  return request({
    url: `/admin/user/${userId}`,
    method: 'delete'
  })
}

// 更改用户状态
export function changeUserStatus(userId, status) {
  return request({
    url: `/admin/user/${userId}/status`,
    method: 'put',
    params: { status }
  })
}

// 获取用户活动记录
export function getUserActivities(userId, params) {
  return request({
    url: `/admin/user/${userId}/activities`,
    method: 'get',
    params
  })
}

// 管理用户群组关联
export function manageUserGroup(data) {
  return request({
    url: '/admin/user/group',
    method: 'post',
    data
  })
}

// 获取用户的群组列表
export function getUserGroups(userId) {
  return request({
    url: `/admin/user/${userId}/groups`,
    method: 'get'
  })
}

// 强制用户下线
export function forceUserOffline(userId) {
  return request({
    url: `/admin/user/${userId}/offline`,
    method: 'put'
  })
}
